/**
 * Catálogo inicial de alimentos — conteúdo PADRÃO da ferramenta, carregado no boot
 * (todos os ambientes) pra a família não começar com a biblioteca vazia.
 *
 * Cada popular (lib/catalogo.ts) vira um Alimento com a ilustração do catálogo
 * (quando houver) e status "não oferecido" (= a experimentar; honesto, ainda não
 * foi testado). Id estável (`mpp-<nome>`) pra ser idempotente entre boots.
 */
import { POPULARES_POR_GRUPO, normalizarNome } from "./catalogo";
import { refIlustracaoPorNome } from "./catalogoImagens";
import {
  GRUPO_LABEL,
  type Alimento,
  type GrupoAlimentar,
  type PropriedadesSensoriais,
} from "../types";

const SENSORIAL_VAZIO: PropriedadesSensoriais = {
  textura: null,
  temperatura: null,
  cor: null,
  forma_apresentacao: null,
  cheiro: null,
};

export function catalogoInicial(): Alimento[] {
  const agora = new Date().toISOString();
  const grupos = Object.entries(POPULARES_POR_GRUPO) as [GrupoAlimentar, string[]][];
  return grupos.flatMap(([grupo, nomes]) =>
    nomes.map((nome) => {
      const ref = refIlustracaoPorNome(nome);
      return {
        id: `mpp-${normalizarNome(nome)}`,
        nome,
        fotos: ref ? [ref] : [],
        marca_produto: null,
        categoria: GRUPO_LABEL[grupo],
        grupo,
        sensorial: { ...SENSORIAL_VAZIO },
        status: "nao_oferecido" as const,
        observacoes: null,
        arquivado: false,
        criado_em: agora,
      };
    }),
  );
}
